<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h4 class="profile-img">Current Camera</h4>
                <div class="cam-device-info" v-if="device">{{ device.label }}</div>
                <div class="border">
                    <vue-web-cam
                        ref="webcam"
                        :device-id="deviceId"
                        height="auto"
                        width="auto"
                        @started="onStarted"
                        @stopped="onStopped"
                        @error="onError"
                        @cameras="onCameras"
                        @camera-change="onCameraChange"
                        :resolution="{width:{ideal:500}, height:{ideal:data && data.btn_text? 1080:500}}"
                    />
                </div>

                
            </div>
            <div class="col-md-6">
                <h4 class="profile-img">Captured Image</h4>
                <div class="cam-device-info" v-if="device">&nbsp;</div>
                <figure class="figure">
                    <img :src="img" class="img-responsive" />
                </figure>
            </div>
        </div>
        <div v-if="device" class="camera row">
            <div class="col-md-6">
                <v-select :items="devicesList" v-model="camera" hide-details>
                    
                </v-select>
            </div>
            <div class="col-md-6 cap-center">
                <v-btn type="button" class="right-btn cust-btn" color="primary" @click="onCapture">Capture Photo</v-btn>
                <v-btn type="button" class="right-btn cust-btn" color="primary" @click="onDone">{{data && data.btn_text? data.btn_text:'Done'}}</v-btn>
                
            </div>
        </div>

        <div v-else class="row">
            <div class="col-md-12">
                <v-btn type="button" @click="onClose({status:false})" class="right-btn cust-btn" color="primary" >Cancel</v-btn>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Camera",  
    props:['onClose','status','data'],  
    data() {
        return {
            img: null,
            camera: null,
            deviceId: null,
            devices: [],
            devicesList:[],
        };
    },
    computed: {
        device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        }
    },
    watch: {
        status(val)
        {
            if(val)
            {
                this.img = "";
                this.onStart();
            }
            else{
                this.onStop();
            }
        },
        camera: function(id) {
            this.deviceId = id;
        },
        devices: function() {
            // Once we have a list select the first one
            const [first, ...tail] = this.devices;
            if (first) {
                this.camera = first.deviceId;
                this.deviceId = first.deviceId;
            }
        }
    },
    methods: {
        onCapture() {
            this.img = this.$refs.webcam.capture();            
            
        },
        onDone() {           
            this.onClose({ status: false, data: { camera:true,base64Image:this.img } })
        },
        onStarted(stream) {
            const webcam = this.$refs.webcam;
      const streams = webcam.stream;

      // Access the video track
      const videoTrack = streams.getVideoTracks()[0];

      // Set the constraints for the new resolution
    //   const newConstraints = {
    //     width: { ideal: 500 },
    //     height: { ideal: 1024 },
    //   };

    //   // Apply the new constraints to the video track
    //   videoTrack.applyConstraints(newConstraints)
    //     .then(() => {
    //       console.log('Video resolution changed successfully');
    //     })
    //     .catch((error) => {
    //       console.error('Error changing video resolution:', error);
    //     });
            console.log("On Started Event", stream);
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
        },
        onStop() {
            this.$refs.webcam.stop();
        },
        onStart() {
    //         const webcam = this.$refs.webcam;
    //   const streams = webcam.stream;

    //   // Access the video track
    //   const videoTrack = streams.getVideoTracks()[0];

    //   // Set the constraints for the new resolution
    //   const newConstraints = {
    //     width: { ideal: 3072 },
    //     height: { ideal: 2304 },
    //   };

    //   // Apply the new constraints to the video track
    //   videoTrack.applyConstraints(newConstraints)
    //     .then(() => {
    //       console.log('Video resolution changed successfully');
    //     })
    //     .catch((error) => {
    //       console.error('Error changing video resolution:', error);
    //     });
            this.$refs.webcam.start();
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            if(cameras)
            {
                this.devicesList=cameras.map(x=>{
                    return {text:x.label,
                    value:x.deviceId}
                })
            }
            console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            console.log("On Camera Change Event", deviceId);
        }
    }
};
</script>